import request from "@/router/axios";

export const getList = (params) => {
    return request({
        url: "/api/produce/safety-check-list/select/page",
        method: "post",
        data: params,
    });
};

export const add = (row) => {
    return request({
        url: "/api/produce/safety-check-list/insert",
        method: "post",
        data: row,
    });
};

export const update = (row) => {
    return request({
        url: "/api/produce/safety-check-list/update",
        method: "post",
        data: row,
    });
};
export const getDetail = (id) => {
    return request({
        url: '/api/produce/safety-check-list/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const remove = (id) => {
    return request({
        url: '/api/produce/safety-check-list/delete/id',
        method: 'get',
        params: {
            id
        }
    })
}

export const changeStatus = (id,type) => {
  return request({
      url: `/api/produce/safety-check-list/${type}/id`,
    method: 'post',
    params: {
      id
    }
  })
}